// src/components/MyDatagridHeader.js
import { TableHead, TableRow, TableCell, TableSortLabel } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import { useListContext } from 'react-admin';
import * as React from 'react';

const MyDatagridHeader = ({ children }) => {
    const { sort, setSort } = useListContext();

    const handleSort = (field) => {
        setSort({
            field,
            order: sort.field === field && sort.order === 'ASC' ? 'DESC' : 'ASC',
        });
    };

    return (
        <TableHead>
            <TableRow>
                {React.Children.map(children, (child, index) => {
                    if (!child.props.source) return <TableCell key={index} />;

                    const isSortable = child.props.sortable !== false;
                    const isSorted = sort.field === child.props.source;
                    const sortDirection = isSorted ? sort.order.toLowerCase() : 'asc';
                    
                    return (
                        <TableCell key={child.props.source || index} onClick={() => isSortable && handleSort(child.props.source)}>
                            {child.props.label || child.props.source}
                            {isSortable && (
                                <TableSortLabel
                                    active={isSorted}
                                    direction={sortDirection}
                                    IconComponent={() => (
                                        isSorted ? (
                                            sortDirection === 'asc' ? <ArrowUpwardIcon fontSize="small" /> : <ArrowDownwardIcon fontSize="small" />
                                        ) : (
                                            <SwapVertIcon fontSize="small" style={{ opacity: 0.3 }} /> // Пример для несортированной колонки
                                        )
                                    )}
                                />
                            )}
                        </TableCell>
                    );
                })}
            </TableRow>
        </TableHead>
    );
};

export default MyDatagridHeader;